export enum LayoutDefinitionType
{
    Unknown = 0,
    HTML = 1,
    Table = 2,
    CrystalReport = 3,
    CoresuiteDesigner = 4,
    ForDashboard = 5
}
export class ReportDetails {
  Id: number;
  Type: LayoutDefinitionType;
  Template?: any;
  SQLStatementId: number;
  Description: string;
  TotalFields?: any;
  AutoExportPDF: boolean = false;
  ColumnSettings: string;
  ExcelTemplatePath?: any;
  ColumnSettingsParsed: any[];
  //FieldDescription: string;
  //RecordDescription: string;
  //Areas: number[];
  dataLoadedForFirstTime: boolean = false;
}
